/**
 * Compare At Price Handler for BSUB Widget
 * Updates compare-at-price display when variant changes
 */

if (!customElements.get('bsub-compare-price-updater')) {
  class BsubComparePriceUpdater extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Listen for variant changes
      document.addEventListener('variant:change', (event) => {
        this.updateComparePrices(event.detail);
      });

      // Also listen for BSUB widget changes
      if (window.BOLD && window.BOLD.BsubWidget) {
        const originalHandleChange = window.BOLD.BsubWidget.handleSellingPlanGroupChange;
        window.BOLD.BsubWidget.handleSellingPlanGroupChange = (event) => {
          originalHandleChange.call(window.BOLD.BsubWidget, event);
          this.updateFromBsubWidget();
        };
      }
    }

    updateComparePrices(variantData) {
      if (!variantData || !variantData.variant) return;

      const variant = variantData.variant;
      const compareAtPrice = variant.compare_at_price;
      const price = variant.price;

      // Update one-time purchase compare-at-price
      const oneTimePriceContainer = document.querySelector('[data-bsub-one-time-price]');
      if (oneTimePriceContainer) {
        this.updatePriceDisplay(oneTimePriceContainer, compareAtPrice, price);
      }
    }

    updateFromBsubWidget() {
      // Get current variant from product JSON
      const productJson = document.querySelector('[data-bsub-product-json]');
      if (!productJson) return;

      try {
        const product = JSON.parse(productJson.textContent);
        const selectedVariantId = document.querySelector('input[name="id"]:checked')?.value;
        
        if (selectedVariantId) {
          const variant = product.variants.find(v => v.id == selectedVariantId);
          if (variant) {
            this.updateComparePrices({ variant });
          }
        }
      } catch (e) {
        console.error('Error updating compare prices:', e);
      }
    }

    updatePriceDisplay(container, compareAtPrice, price) {
      // Remove existing compare price
      const existingComparePrice = container.querySelector('.bsub-widget__compare-price');
      if (existingComparePrice) {
        existingComparePrice.remove();
      }

      // Add compare price if it exists and is higher than current price
      if (compareAtPrice && compareAtPrice > price) {
        const comparePriceElement = document.createElement('s');
        comparePriceElement.className = 'bsub-widget__compare-price';
        comparePriceElement.textContent = this.formatMoney(compareAtPrice);
        
        // Insert before the price span
        const priceSpan = container.querySelector('.bsub-widget__price');
        if (priceSpan) {
          container.insertBefore(comparePriceElement, priceSpan);
        } else {
          container.insertBefore(comparePriceElement, container.firstChild);
        }
      }
    }

    formatMoney(cents) {
      // Get money format from Shopify settings
      const moneyFormatData = document.querySelector('[data-bsub-money-format]');
      let moneyFormat = '{{amount}}';
      
      if (moneyFormatData) {
        try {
          moneyFormat = moneyFormatData.textContent.replace(/['"]/g, '');
        } catch (e) {
          console.error('Error parsing money format:', e);
        }
      }

      // Simple money formatting
      const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return moneyFormat.replace('{{amount}}', amount);
    }
  }

  customElements.define('bsub-compare-price-updater', BsubComparePriceUpdater);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('bsub-compare-price-updater')) {
      const updater = document.createElement('bsub-compare-price-updater');
      document.body.appendChild(updater);
    }
  });
} else {
  if (!document.querySelector('bsub-compare-price-updater')) {
    const updater = document.createElement('bsub-compare-price-updater');
    document.body.appendChild(updater);
  }
}
